import {firstValueFrom, take} from 'rxjs';
import {connect} from '@wagmi/core';
import {WalletConnectConnector} from '@wagmi/core/connectors/walletConnect';
import {projectId} from '@/const/wallet-connect';
import {bridge} from '@/helper/bridge';
import {CustomObservableError} from '@/streams/utils';
import {chains, connectChainId} from '../shared';
import {disconnect} from './disconnect';
import {connector$, watchAutoConnect} from './connector';
import {defineWalletConnectBridge, shouldUseAppWalletConnect$} from '../bridge';

const APP_CONNECT_METHOD_NAME = 'appConnect';
let connectSuccessCallback;
let connectErrorCallback;
export const walletConnectConnector =
  process.browser &&
  new WalletConnectConnector({
    chains,
    options: {
      projectId,
    },
  });

/**
 * 连接wallet-connect
 */
export async function connectWalletConnectWallets() {
  const data = await new Promise((resolve, reject) => {
    shouldUseAppWalletConnect$.pipe(take(1)).subscribe((shouldUseAppWalletConnect) => {
      if (shouldUseAppWalletConnect) {
        connectSuccessCallback = resolve;
        connectErrorCallback = reject;
        bridge.postJSON({type: 'walletConnect', callback: APP_CONNECT_METHOD_NAME});
        return;
      }
      connectByWeb().then(resolve).catch(reject);
    });
  });
  return data;
}

defineWalletConnectBridge(() => {
  (window as any)[APP_CONNECT_METHOD_NAME] = function (result) {
    try {
      const {code, msg, data} = JSON.parse(result);
      if (code == 0) {
        const {walletSource: connectorType, walletName: walletType, address} = data;
        connectSuccessCallback({connectorType, walletType, address});
        return;
      }
      connectErrorCallback(new Error(msg));
    } catch (error) {
      connectErrorCallback(error);
    }
  };
});

export async function connectByWeb() {
  const connector = await firstValueFrom(connector$);
  const {connector: connectingConnector} = connector;
  // TODO: 强制断开，打开modal，让用户重新选择钱包
  if (connectingConnector?.isConnected) {
    await disconnect();
  }
  try {
    await connect({connector: walletConnectConnector, chainId: connectChainId});
  } catch (error) {
    if (error?.message?.includes('Connection request reset')) {
      throw new CustomObservableError(error.message);
    }
    throw error;
  }
  // 监听自动连接
  const {promise: autoConnectedPromise, subscription: autoConnectedSubscription} = watchAutoConnect();

  try {
    const data = await autoConnectedPromise;
    autoConnectedSubscription.unsubscribe();
    return data;
  } catch (error) {
    autoConnectedSubscription.unsubscribe();
    throw error;
  }
}
